module.exports = __webpack_public_path__ + "static/sml-plaza-6a6e8ebe7eb4ad249e70d5149c18fcc0.png";